import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse, unwrapApiResponse } from '@/api/patterns/crud';
import type {
  PlatformExternalRequest,
  GetExternalRequestsArgs,
  UpdateExternalRequestStatusArgs,
} from '../types';

export const platformExternalRequestsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformExternalRequests: builder.query<PlatformExternalRequest[], GetExternalRequestsArgs | void>({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.requestType) params.set('requestType', args.requestType);
        params.set('limit', String(args?.limit ?? 500));
        return `/platform/external-requests?${params.toString()}`;
      },
      transformResponse: unwrapListResponse<PlatformExternalRequest>,
      providesTags: [{ type: 'ExternalRequests', id: 'LIST' }],
    }),

    updateExternalRequestStatus: builder.mutation<PlatformExternalRequest, UpdateExternalRequestStatusArgs>({
      query: ({ id, status }) => ({
        url: `/platform/external-requests/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      transformResponse: unwrapApiResponse<PlatformExternalRequest>,
      invalidatesTags: [{ type: 'ExternalRequests', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPlatformExternalRequestsQuery,
  useUpdateExternalRequestStatusMutation,
} = platformExternalRequestsApi;
